import { useSelector } from 'react-redux';

import { TrlFeedbackModal } from '»components/molecules/TrlFeedbackModal';
import { usePageNavigation } from '»utils/customHooks';

import { isJoiningProcessCompleted } from '../../redux';

export const CompletedProcessModal = () => {
  const isProcessCompleted = useSelector(isJoiningProcessCompleted);

  const { navigateToPage } = usePageNavigation();

  const handleCloseModal = (_, reason) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;

    navigateToPage({
      route: '/',
      menuItem: 'LANDING_PAGE',
      shouldResetAuth: true,
      shouldResetQuest: true,
    });
  };

  return (
    <TrlFeedbackModal
      title={{ content: 'TRLT_UI-JOIN_PROCESS_COMP' }}
      descr={{
        content: 'TRLT_UI-JOIN_PROCESS_COMP_DESCR',
      }}
      type="success"
      open={isProcessCompleted}
      onClose={handleCloseModal}
      isFromOnboarding
    />
  );
};
